import { IInterpolationCache, ILangProvider } from './interfaces';

import { glossaryProcessor } from './glossary-lookup';

export class InterpolationCache implements IInterpolationCache {
  private readonly handlebars: any;
  private readonly cachedContent: Map<string, any> = new Map();
  private readonly langProvider: ILangProvider;

  public constructor(langProvider: ILangProvider) {
    this.langProvider = langProvider;
    this.handlebars = this.createConfiguredHandlebars();
  }

  asLanguage(language: string): InterpolationCache {
    if (this.langProvider.currentLanguage !== language) {
      return new InterpolationCache(this.langProvider.asLanguage(language));
    }
    return this;
  }

  getRawInterpolated(language: string, content: string): string {
    const cacheKey = `${language}|raw:${content}`;
    const template = this.cachedContent.get(cacheKey) || this.handlebars.compile(content);
    this.cachedContent.set(cacheKey, template);
    const currentLang = this.langProvider.currentLanguage;
    try {
      if (currentLang !== language) {
        this.langProvider.currentLanguage = language;
      }
      return template({});
    } finally {
      this.langProvider.currentLanguage = currentLang;
    }
  }

  private createConfiguredHandlebars(): any {
    const handlebars = globalThis.Handlebars;
    // Override the escapeExpression function
    handlebars.Utils.escapeExpression = function (str) {
      // Custom escaping logic or just return the string unescaped
      return str;
    };
    // Register a helper for glossary
    handlebars.registerHelper('glossary', (key: string, optionValue?: string) => {
      return new this.handlebars.SafeString(glossaryProcessor(this.langProvider, key, optionValue));
    });

    return handlebars;
  }

  public flushCache(): void {
    this.cachedContent.clear();
  }

  public getInterpolated(
    language: string,
    languageId: string,
    segmentName: string,
    content: string,
    parameters: object
  ): string {
    const cacheKey = `${language}|${languageId}|${segmentName}`;
    const template = this.cachedContent.get(cacheKey) || this.handlebars.compile(content);
    this.cachedContent.set(cacheKey, template);
    const currentLang = this.langProvider.currentLanguage;
    try {
      if (currentLang !== language) {
        this.langProvider.currentLanguage = language;
      }
      const value = template(parameters);
      return value;
    } finally {
      this.langProvider.currentLanguage = currentLang;
    }
  }
}
